import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity';
import Table from 'components/molecules/table/Table';
import PendingsChart from 'components/organisms/statistics/AllCharts/PendingsChart';
import { leaveRequestsHeaders } from 'lib/helpers/constants/columns/leaveRequestsHeaders';
import React, { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';


interface IProps {
    data: any;
}

const Leaves: FC<IProps> = ({ data }) => {

    const { t } = useTranslation()

    const [HoveredSlice, setHoveredSlice] = useState<string | null>(null)


    const FormattedData = useMemo(() => {
        return (data as any)?.grouped_by_type

    }, [data])

    if(data?.data?.length === 0) { 
        return (
            <EmptyEntity name='Absences' />
        )
    }

    return (
        <div className='flex flex-col gap-7'>
            <div className="flex flex-col gap-20 2xl:flex-row relative rounded-[10px]  p-5 border border-border flex-wrap 2xl:flex-nowrap">
                <div className="basis-1/3 flex flex-col gap-5 h-full ">
                    <div className='font-inter-medium text-xl text-primaryTextColor'>
                        {t('Total absences')}
                    </div>
                    <div>
                        <PendingsChart
                            setHoveredSlice={setHoveredSlice}
                            data={
                                Object.keys(FormattedData).map((key) => {
                                    return {
                                        name: key,
                                        y: FormattedData[key] / data.approved_absence_count * 100,
                                        z: 100
                                    }
                                })}
                        />
                    </div>
                </div>

                <div className="basis-2/3">
                    <div className="grid-cols-2 grid gap-2">
                        {Object.keys(FormattedData).map((key, index) => {
                            const item = {
                                status: key,
                                count: FormattedData[key],
                            };
                            return (
                                <div
                                    onMouseEnter={() => setHoveredSlice(FormattedData[key])}
                                    onMouseLeave={() => setHoveredSlice(null)}
                                    key={index}
                                    className={`flex justify-between gap-3 items-center transition-colors rounded-[8px] py-[8px] px-[20px] col-span-1 
                                        ${item.status === HoveredSlice
                                            ? 'text-white bg-[#EFBE12] border-[#EFBE12]'
                                            : 'text-primaryTextColor border border-[#F2F4F7]'} `
                                    }>
                                    <div className="font-inter-medium">
                                        {t(item.status)}
                                    </div>
                                    <div className="font-inter-bold">
                                        {item.count}
                                    </div>
                                </div>
                            )
                        })}
                        <div
                            className={`flex justify-between gap-3 items-center transition-colors rounded-[8px] py-[8px] px-[20px] col-span-2
                                    text-primaryTextColor border border-[#F2F4F7]`
                            }>
                            <div className="font-inter-medium">
                                {t('Total')}
                            </div>
                            <div className="font-inter-bold">
                                {data.approved_absence_count}
                            </div>
                        </div>
                         <div
                            className={`flex justify-between gap-3 items-center transition-colors rounded-[8px] py-[8px] px-[20px] col-span-2
                                    text-primaryTextColor border border-[#F2F4F7]`
                            }>
                            <div className="font-inter-medium">
                                {t('Total Vacation Days')}
                            </div>
                            <div className="font-inter-bold">
                                {data.approved_vacation_absence_days ?? '-'} / {data.usertotalAbsencesDays ?? '-'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='space-y-2'>
                <div className='font-inter-medium text-xl text-primaryTextColor'>
                    {t("All Leaves")} ({data?.data?.length})
                </div>
                <Table
                    search=''
                    columns={leaveRequestsHeaders}
                    data={data?.data}

                />
            </div>

        </div>
    )
}

export default Leaves